(function (root) {
  'use strict';
  function quote(rows) {
    let quantity = 0, subtotal = 0;
    const lineSubtotals = [];
    for (const row of rows) {
      if (!Number.isSafeInteger(row.quantity) || row.quantity < 0 || !Number.isSafeInteger(row.price) || row.price < 0) throw new RangeError('Use whole pairs and prices in cents.');
      quantity += row.quantity;
      subtotal += row.quantity * row.price;
      lineSubtotals.push(row.quantity * row.price);
    }
    if (!Number.isSafeInteger(subtotal) || !Number.isSafeInteger(quantity)) throw new RangeError('Bundle is too large.');
    const discountPercent = quantity >= 10 ? 30 : quantity >= 5 ? 20 : quantity >= 3 ? 10 : 0;
    // Match the store's KCART checkout: round the discount down to whole cents.
    const savings = Math.floor(subtotal / 100) * discountPercent + Math.floor((subtotal % 100) * discountPercent / 100);
    const total = subtotal - savings;
    const payablePercent = 100 - discountPercent;
    const lineTotals = lineSubtotals.map(amount=>Math.floor(amount / 100) * payablePercent + Math.floor((amount % 100) * payablePercent / 100));
    const pennies = total - lineTotals.reduce((sum,amount)=>sum+amount,0);
    // Allocate rounding pennies by largest remainder; input order breaks ties.
    const rankedLines = lineSubtotals.map((amount,index)=>({index,remainder:(amount % 100) * payablePercent % 100})).sort((a,b)=>b.remainder-a.remainder || a.index-b.index);
    for (let penny=0; penny<pennies; penny++) lineTotals[rankedLines[penny].index]++;
    const nextTier = [{quantity:3,percent:10},{quantity:5,percent:20},{quantity:10,percent:30}].find(tier=>tier.quantity>quantity) || null;
    return {quantity, subtotal, total, savings:subtotal-total, discountPercent, nextTier, lineTotals};
  }
  const api = {quote};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.BundlePricing = api;
})(typeof globalThis !== 'undefined' ? globalThis : this);
